import React, { useState } from 'react';
import { Container, Nav, Navbar } from "react-bootstrap";
import "../css/NavBar.css";
import PopupPatch from './popupPatch/PopupPatch';
import SMLSLoginModal from "./SmlsLoginModal";
import AnchorLink from "react-anchor-link-smooth-scroll";

const Separator = ({ className }) => <div className={
    className ? `separator ${className}` : "separator"
}></div>

const NavBar = () => {

    const [showSMLSLoginModal, setShowSMLSLoginModal] = useState(false);
    const [actionType, setActionType] = useState("");

    const handleSubmitLoan = (e) => {
        setShowSMLSLoginModal(true);
        setActionType("newLoan");
    };

    const handleViewPipeline = (e) => {
        setShowSMLSLoginModal(true);
        setActionType("checkLoan");
    };

    function handleSMLSLoginModalClose() {
        // window.location.reload(false);
        setShowSMLSLoginModal(false);
    }

    /** change thumbnail of navbar toggle icon */
    const iconChanger = () => {

        const navOpenIndicatorClass_closed = document.querySelectorAll('.navbar-collapse')
        const navOpenIndicatorClass_open = document.querySelectorAll('.navbar-collapse.show')

        const navTogglerIcon = document.getElementsByClassName('navbar-toggler-icon')[0]

        if (navOpenIndicatorClass_closed.length !== 0) {
            navTogglerIcon.classList.add('nav-close-icon')
        }

        if (navOpenIndicatorClass_open.length !== 0) {
            navTogglerIcon.classList.remove('nav-close-icon')
        }
    }

    const isPrimeJumbo = process.env.REACT_APP_URL === 'nonconformingloans' 

    return (
        <div className="whl-navbar">
            <Container fluid className="pr-0">
                <Navbar expand="md">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={
                        () => iconChanger()
                    } />
                    <Navbar.Collapse className="pr-0" id="responsive-navbar-nav">
                        <Nav className="ml-md-0s ml-lg-autos">
                            {/* <Separator /> */}
                            <a
                                href="tel:+18334786937"
                                rel="noreferrer"
                                className="navLink"
                            >
                                <i className="fas fa-phone-volume"></i>&nbsp;(833) 478-6937
                            </a>
                            <Separator className = {
                                `${
                                    isPrimeJumbo ? 'prime-jumbo-page-separator' : ''
                                }`
                            } />
                            <AnchorLink
                                href="#postPricingScrollRef"
                                className="navLink"
                            >
                                See Our Rates
                            </AnchorLink>
                            <Separator className = {
                                `${
                                    isPrimeJumbo ? 'prime-jumbo-page-separator' : ''
                                }`
                            } />
                            <Nav.Link
                                onClick={handleSubmitLoan}
                                rel="noreferrer"
                                className="navLink"
                            >
                                Submit Loan
                            </Nav.Link>
                            <Separator className = {
                                `${
                                    isPrimeJumbo ? 'prime-jumbo-page-separator' : ''
                                }`
                            } />
                            <Nav.Link
                                onClick={handleViewPipeline}
                                rel="noreferrer"
                                className="navLink"
                            >
                                View Pipeline
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                {/* </Navbar> */}
            </Container >
            <div id="scrollRef" style={{
                width: '0',
                height: '0'
            }}></div>

            {showSMLSLoginModal && (
                <SMLSLoginModal
                    showModal={showSMLSLoginModal}
                    modalClose={handleSMLSLoginModalClose}
                    actionType={actionType}
                />
            )}
        </div>
    );
}

export default NavBar;